import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router";

import { Formik, Form } from "formik";
import { companyActions } from "../../../../redux/actions";
import Topbar from "../../../../shared/components/topbar/Topbar";
import Button from "../../../../shared/components/Buttons/Button";
import InputTextField from "../../../../shared/components/inputTextField/InputTextField";
import { addCompanyValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import {
  buttonTypeConstants,
  buttonNameConstants,
  routesPathConstants,
  globalConstants,
  companyConstants,
  countryConstants,
  EMPTY_STRING,
} from "../../../../constants";
import StoreAddressFields from "../../../../shared/components/store/StoreAddressFields";
import PhoneInputField from "../../../../shared/components/phoneInputField/PhoneInputField";
import InputPasswordField from "../../../../shared/components/inputPasswordField/InputPasswordField";
import {
  createCompanyDynamicUrl,
  isSpinnerEnabled,
} from "../../../../shared/utility";
import { decryptObject } from "../../../../system/encryption";

//-------AddNewCompany component start here
const AddNewCompany = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  //-------Props
  const { addNewCompany, updateCompany, spinnerArray } = props;
  //-------Stores Reducer
  const { stores } = props.store;
  //-------initial state for form
  const initialValues = {
    city: state?.data?.city || EMPTY_STRING,
    state: state?.data?.state || EMPTY_STRING,
    email: state?.data?.email || EMPTY_STRING,
    line1: state?.data?.line1 || EMPTY_STRING,
    password:
      (state?.isEdit &&
        decryptObject(
          state?.data?.password,
          process.env.REACT_APP_PASSWORD_ENCRYPTED_KEY
        )) ||
      EMPTY_STRING,
    line2: state?.data?.line2 || EMPTY_STRING,
    phoneNumber: state?.data?.phoneNumber || EMPTY_STRING,
    countryCode:
      state?.data?.countryCode || countryConstants.DEFAULT_COUNTRY_CODE,
    companyName: state?.data?.companyName || EMPTY_STRING,
    isDummyCompany: state?.data?.isDummyCompany || false,
    zip: state?.data?.zip || EMPTY_STRING,
    ownerNamePlaceholder: state?.data?.ownerNamePlaceholder || EMPTY_STRING,
    domainUrl: state?.data?.domainUrl || EMPTY_STRING,
  };

  //-------handle submit for add new device form
  const handleSubmit = (data) => {
    delete data["domainUrl"];
    if (state?.isEdit) {
      updateCompany({ ...data, id: state?.data?.id });
    } else {
      addNewCompany(data);
    }
  };

  //-------handle cancel button
  const handleCancelButton = () => {
    navigate(createCompanyDynamicUrl(routesPathConstants.ADMIN_COMPANIES));
  };

  return (
    <>
      <Topbar
        title={state?.isEdit ? "Edit Company" : "New Company"}
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.ADMIN_COMPANIES,
        }}
      />
      <Row className="m-0 p-0 w-100">
        <Formik
          initialValues={initialValues}
          validate={addCompanyValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form className="m-0">
              <Row className="m-0">
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="companyName"
                    label="Company Name"
                    placeHolder="Enter Company Name"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <PhoneInputField
                    name="phoneNumber"
                    label="Phone Number"
                    defaultCountry={
                      values.countryCode ||
                      countryConstants.DEFAULT_COUNTRY_CODE
                    }
                    isSupportedCountriesOnly={true}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="email"
                    label="Email"
                    placeHolder="Enter Email"
                  />
                </Col>
                <Col md={6} className="mb-3 d-flex gap-2">
                  <InputPasswordField
                    name="password"
                    label="Password"
                    placeHolder="Enter Password"
                    className="w-100"
                  />
                </Col>
                <StoreAddressFields isShowCurrency={false} />
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="ownerNamePlaceholder"
                    placeHolder="Enter Owner Name"
                    label="Owner Name"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="domainUrl"
                    label="Domain Url"
                    placeHolder={state?.data?.domainUrl || "Auto Generated"}
                    disabled={true}
                  />
                </Col>
                <Col md={6} className="mb-3 d-flex gap-2">
                  <Button
                    type="button"
                    label={buttonNameConstants.CANCEL}
                    handleClick={() => {
                      handleCancelButton();
                    }}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    isDisabled={
                      isSpinnerEnabled(
                        spinnerArray,
                        companyConstants.CREATE_DUMMY_COMPANY
                      ) ||
                      isSpinnerEnabled(
                        spinnerArray,
                        companyConstants.UPDATE_COMPANY
                      )
                    }
                    className="w-100"
                  ></Button>
                  <Button
                    type="submit"
                    className="w-100"
                    label={
                      state?.isEdit
                        ? buttonNameConstants.UPDATE
                        : buttonNameConstants.SAVE
                    }
                    isDisabled={
                      isSpinnerEnabled(
                        spinnerArray,
                        companyConstants.CREATE_DUMMY_COMPANY
                      ) ||
                      isSpinnerEnabled(
                        spinnerArray,
                        companyConstants.UPDATE_COMPANY
                      )
                    }
                  ></Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
}; //-------AddNewCompany component end here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  store: state.store,
  spinnerArray: state.system.spinnerArray,
  company: state.authentication.company,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addNewCompany: (data) => dispatch(companyActions.addNewCompany(data)),
  updateCompany: (data) => dispatch(companyActions.updateCompany(data)),
});

//-------Export AddNewCompany Component
export default connect(mapStateToProps, mapDispatchToProps)(AddNewCompany);
